function isSameBlock(anchorPath, focusPath) {
  return anchorPath[0] === focusPath[0];
}
export default isSameBlock;
